import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Input, Spinner } from 'reactstrap';
import { ref, get, set, update, onValue, increment, runTransaction } from "firebase/database";
import moment from 'moment';
import { errorToast } from '../../../common/toast';
import { db } from '../../../../firebase';

const fetchRandomPara = async () => {
    const response = await fetch('https://baconipsum.com/api/?type=meat-and-filler&paras=2&format=text');
    const data = await response.text();
    return data?.replace(/\s+/g, ' ')?.trim();
};

const CurrentWorkLoad = () => {
    const [currentParagraph, setCurrentParagraph] = useState('');
    const [userInput, setUserInput] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalParagraphs, setTotalParagraphs] = useState(0);
    const [taskDone, setTaskDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const userData = JSON.parse(localStorage.getItem('user') || '{}');

    const fetchTotalParagraphs = async () => {
        try {
            setInitialLoading(true);
            const packageRef = ref(db, `packages/${userData?.plan?.value}`);
            const packageSnapshot = await get(packageRef);
            if (packageSnapshot.exists()) {
                const packageData = packageSnapshot.val();
                setTotalParagraphs(packageData?.noOfForms || 0);
            } else {
                errorToast("No package data found.");
            }
        } catch (error) {
            errorToast("Error fetching package data: ", error);
        } finally {
            setInitialLoading(false);
        }
    };

    const fetchCurrentIndex = async () => {
        try {
            setInitialLoading(true);
            const formsRef = ref(db, `userForms/${userData?.uid}`);
            const formsSnapshot = await get(formsRef);

            if (formsSnapshot.exists()) {
                const formsData = formsSnapshot.val();
                const paraKeys = Object.keys(formsData).filter((key) => key.startsWith('para'));
                const currentParagraphCount = paraKeys.length;
                setCurrentIndex(currentParagraphCount);
                if (currentParagraphCount >= totalParagraphs) setTaskDone(true);
            } else {
                setCurrentIndex(0);
            }
        } catch (error) {
            errorToast("Error fetching current index: ", error);
        } finally {
            setInitialLoading(false);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);  // Start loading
        try {
            const formsRef = ref(db, `userForms/${userData?.uid}`);
            const paraKey = `para${currentIndex + 1}`;
            const isCorrect = userInput?.trim() === currentParagraph?.trim();

            // Check if the user has a form entry; if not, create one
            const userFormsSnapshot = await get(formsRef);

            if (userFormsSnapshot.exists()) {
                // Update the existing form entry with the new data
                await update(formsRef, {
                    [paraKey]: {
                        original: currentParagraph,
                        userInput: userInput,
                    },
                });
            } else {
                // Create a new form entry for the user
                await set(formsRef, {
                    userId: userData?.uid,
                    [paraKey]: {
                        original: currentParagraph,
                        userInput: userInput,
                    },
                });
            }

            // Handling QC reports
            const qcReportsRef = ref(db, `qcReports`);
            const qcReportsSnapshot = await get(qcReportsRef);

            let userQCReportKey = null;
            let existingQCData = null; // Store the existing QC data here

            // Iterate over child nodes to find the matching report
            qcReportsSnapshot.forEach((childSnapshot) => {
                const qcData = childSnapshot.val();

                if (qcData.userId === userData?.uid) {  // Match the userId
                    userQCReportKey = childSnapshot.key;  // Get the key of the existing entry
                    existingQCData = qcData; // Save the existing data for later use
                }
            });

            if (userQCReportKey && existingQCData) {
                const qcReportRef = ref(db, `qcReports/${userQCReportKey}`);

                // Only update the 3 fields
                await update(qcReportRef, {
                    rightForms: existingQCData.rightForms ?
                        (isCorrect ? existingQCData.rightForms + 1 : existingQCData.rightForms) : (isCorrect ? 1 : 0),
                    wrongForms: existingQCData.wrongForms ?
                        (isCorrect ? existingQCData.wrongForms : existingQCData.wrongForms + 1) : (isCorrect ? 0 : 1),
                    submittedForms: existingQCData.submittedForms ? existingQCData.submittedForms + 1 : 1,
                });

            } else {
                errorToast("Your QC report is not created. Please contact the administrator.");
            }

            setUserInput('');  // Clear user input
            setCurrentIndex((prev) => prev + 1);  // Move to the next paragraph

            // Fetch new paragraph if not completed all
            if (currentIndex < totalParagraphs - 1) {
                const newParagraph = await fetchRandomPara();
                setCurrentParagraph(newParagraph);
            } else {
                setTaskDone(true);
            }

        } catch (error) {
            errorToast("Error adding or updating data: ", error);
        } finally {
            setLoading(false);  // Stop loading
        }
    };


    const handleInputChange = (e) => {
        setUserInput(e.target.value);
    };

    useEffect(() => {
        const loadParagraph = async () => {
            try {
                const randomParagraph = await fetchRandomPara();
                setCurrentParagraph(randomParagraph);
            } finally {
                setInitialLoading(false);
            }
        };
        loadParagraph();
        fetchTotalParagraphs();
    }, []);

    useEffect(() => {
        if (totalParagraphs) {
            fetchCurrentIndex();
        }
    }, [totalParagraphs]);

    const endDateWithTime = moment(userData?.endDate).endOf('day');
    const isBeforeEndDate = moment().isBefore(endDateWithTime);

    return !isBeforeEndDate ? (
        <h3 className="text-success text-center">Your task is already done! Check your QC reports</h3>
    ) : userData?.startDate && moment(userData?.startDate).isAfter(moment()) ? (
        <h3 className="text-warning text-center">
            Your time has not started yet! Please come back on {moment(userData?.startDate).format('MMMM Do YYYY, h:mm A')}.
        </h3>
    ) : (
        <div>
            <Container className="mt-4">
                <h4>Current Work Load</h4>
                {initialLoading ? (
                    <div className="text-center">
                        <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                        <p>Loading your current workload...</p>
                    </div>
                ) : taskDone ? (
                    <h3 className="text-success text-center">Your task is done!</h3>
                ) : (
                    <>
                        <h6>Current Paragraph Number: {currentIndex + 1}/{totalParagraphs}</h6>

                        <Row className="mt-3">
                            <Col md="6">
                                <Card className="no-copy-card">
                                    <CardBody>
                                        <p>{currentParagraph}</p>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col md="6">
                                <Input
                                    type="textarea"
                                    value={userInput}
                                    onChange={handleInputChange}
                                    placeholder="Type your response here..."
                                    style={{ minHeight: '200px' }}
                                />
                                <div className="mt-3">
                                    <Button color="primary" className="mr-2" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Spinner size="sm" className="me-2" /> : "Submit"}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </>
                )}
            </Container>
        </div>
    );
};

export default CurrentWorkLoad;
